export const CONSENT_FORM_TYPES = {
  add: 'add',
  update: 'update',
};
